import { Select } from "@fluentui/react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { usePaymentPageStore } from "store/PaymentPageStore";

type Props = {
  name: string;
  required?: boolean;
  disabled?: boolean;
  value?: any;
  visible?: boolean;
  isLoading: boolean;
  onBlur?: (e: any) => void;
};

export const SearchDateFilterField = ({
  name,
  required = false,
  disabled = false,
  visible,
  isLoading,
  onBlur = null,
}: Props) => {
  const { t } = useTranslation();
  const [{ searchDateFilterField }, { setPaymentStoreValue }] =
    usePaymentPageStore();

  if (!visible) return null;
  return (
    <>
      <Select
        data-help="payments-date-field"
        required={required}
        disabled={disabled || isLoading}
        id={name}
        name={"searchDateFilterField"}
        onBlur={(e) => {
          onBlur && onBlur(e);
        }}
        onChange={(e, data) => {
          setPaymentStoreValue("searchDateFilterField", data.value);
        }}
        value={searchDateFilterField || ""}
        title={t("pct.taxonomy.selectTitle.label")}
      >
        <option key={"paymentDate"} value={"paymentDate"}>
          {t("pct.paymentDate.label")}
        </option>
        <option key={"createdAt"} value={"createdAt"}>
          {t("pct.clearedAt.label")}
        </option>
        <option key={"bookingDate"} value={"bookingDate"}>
          {t("pct.bookingDate.label")}
        </option>
        <option key={"declaredAt"} value={"declaredAt"}>
          {t("pct.declaredAt.label")}
        </option>
        <option key={"insurerReportDate"} value={"insurerReportDate"}>
          {t("pct.insurerReportDate.label")}
        </option>
      </Select>
    </>
  );
};

export default SearchDateFilterField;
